import { FormattedMessage } from "react-intl";
import { UpgradeNowIcon } from "../../icons/UpgradeNowIcon";
import styles from "./AlertNotification.module.scss";
import { useSelector } from "redux/hooks";
import { RoutePaths } from "pages/routePaths";
import useRouter from "hooks/useRouter";
import { useState, useEffect } from "react";
import AnimatedModal from "components/AnimateModal/AnimateModal";
import { setUpgradeMemberModel } from "redux/actions";
import classNames from "classnames";

interface Iprops {
  mdNav?: boolean;
  displayDetail?: boolean;
}
export const AlertNotification = ({ mdNav, displayDetail }: Iprops) => {

  const { userDetail, creditLimits, theme } = useSelector((state) => state.authReducer);
  const { push } = useRouter();
  const [upgradedModel, setUpgradedModel] = useState(false);
  const freeTrial = userDetail?.user?.activeSubscription?.name === "Free";

  const [creditPercentage, setCreditPercentage] = useState<number>(0);

  const getReaminingCredits = (): number => {
    if (
      userDetail?.user.team.role === "admin" 
    ) {
      const subscription = userDetail?.user.activeSubscription;

      if (!subscription) return 0;

      const totalCredits = subscription.total_credits || 0;
      const remainingCredits = subscription.credits || 0; // This is remaining, not used

      if (totalCredits === 0) return 0;

      // Calculate used credits
      const usedCredits = totalCredits - remainingCredits;

      // Calculate percentage of total credits used
      const percentage = Math.floor((usedCredits / totalCredits) * 100);

      return percentage > 0 ? percentage : 0;
    } else {
      const dailyLimit = creditLimits.daily_limit || 0;
      const usedToday = creditLimits.used_today || 0;
      if (dailyLimit === 0) return 100; // Prevent division by zero

      // Calculate percentage of used daily credits
      const percentage = Math.floor((usedToday / dailyLimit) * 100);
      return percentage;
    }
  };

  useEffect(() => {
    const newCredits = getReaminingCredits();
    setCreditPercentage(newCredits);
  }, [
    userDetail?.user.activeSubscription.credits,
    creditLimits.used_today,
    userDetail?.user.team.role,
    creditLimits.daily_limit,
  ]);

  const handleUpgradeClick = () => {
    if (userDetail?.user.team.role === "admin") {
      push(`/${RoutePaths.Settings}/${RoutePaths.CurrentPlan}`)
    } else {
      setUpgradeMemberModel(true);
      setUpgradedModel(false);
    }
  };

  const isCreditZero =
    (userDetail?.user.team.role === "admin")
      ? userDetail?.user?.activeSubscription?.credits === 0
      : creditLimits?.daily_limit > 0 && creditLimits?.used_today >= creditLimits?.daily_limit;


  return (
    <>
    {(isCreditZero || freeTrial || creditPercentage >= 80 ) && (
    <>
      <div className={classNames("font-inter",styles.alertContainer, {
        [styles.displayEnd]: !displayDetail || mdNav,
      })}>
        <div className={`${!displayDetail || mdNav ? "cursor-pointer" :""} ${styles.alert}`} onClick={() => (mdNav || !displayDetail) && setUpgradedModel(true)}
          style={{ border: isCreditZero ? "0.5px solid #DC2626" : freeTrial ? "0.5px solid #2563EB" : "0.5px solid #D97706", background: isCreditZero ? "#FEE2E2" : freeTrial ? "#DBEAFE" : "#FEF3C7" }}>
          <h2 className={styles.alertText}
            style={{ color: isCreditZero ? "#DC2626" : freeTrial ? "#2563EB" : "#D97706" }}>
            {isCreditZero ? (
              <FormattedMessage id="modal.inviteTeam.creditLimit.placeholder" />
            ) : freeTrial ? (
              <FormattedMessage id="toolbar.free.trial" />
            ) : (
              <FormattedMessage id="tolbar.usage.alert" />
            )}

          </h2>
        </div>
        {(displayDetail && !mdNav) && (
          <>
            <div className={classNames("font-inter",styles.alertSubTitle, {
              [styles.light]: theme === "light",
              [styles.dark]: theme === "dark",
            })} >
              {isCreditZero ? (
                <FormattedMessage id="toolbar.credit.limit.notification" />
              ) : freeTrial ? (
                <FormattedMessage
                  id="toolbar.free.trial.notification"
                  values={{
                    highlightedTxt: (chunks: React.ReactNode) => (
                      <span style={{ color: '#2563EB', fontWeight: 700 }}>{chunks}</span>
                    ),
                  }}
                />
              ) : (
                <FormattedMessage
                  id="tolbar.usage.alert.notification"
                  values={{
                    percentage: creditPercentage,
                    highlightedTxt: (chunks: React.ReactNode) => (
                      <span style={{ color: '#D97706', fontWeight: 700 }}>{chunks}</span>
                    ),
                  }}
                />)}
            </div>
            <div className={styles.upgradeNow} onClick={handleUpgradeClick}>
              <h2 className={styles.upgradeText}
                style={{ color: isCreditZero ? "#DC2626" : freeTrial ? "#2563EB" : "#D97706" }}>
                {isCreditZero ? (
                  <FormattedMessage id="settings.plan.feature.buyCredits" />
                ) : (
                  <FormattedMessage id="tolbar.usage.alert.btn" />
                )}
              </h2>
              <span className="flex-shrink-0 leading-[0]">
                <UpgradeNowIcon color={isCreditZero ? "#DC2626" : freeTrial ? "#2563EB" : "#D97706"} />
              </span>
            </div>
          </>
        )}
      </div>

      {(upgradedModel && (mdNav || !displayDetail)) && (
        <AnimatedModal
          credits={true}
          isOpen={upgradedModel}
          onClose={() => setUpgradedModel(false)}
        >
          <div className="font-inter flex flex-col gap-[12px]">
            <div className={classNames("font-inter",styles.alertSubTitle, {
              [styles.light]: theme === "light",
              [styles.dark]: theme === "dark",
            })} >
              {isCreditZero ? (
                <FormattedMessage id="toolbar.credit.limit.notification" />
              ) : freeTrial ? (
                <FormattedMessage
                  id="toolbar.free.trial.notification"
                  values={{
                    highlightedTxt: (chunks: React.ReactNode) => (
                      <span style={{ color: '#2563EB', fontWeight: 700 }}>{chunks}</span>
                    ),
                  }}
                />
              ) : (
                <FormattedMessage
                  id="tolbar.usage.alert.notification"
                  values={{
                    percentage: creditPercentage,
                    highlightedTxt: (chunks: React.ReactNode) => (
                      <span style={{ color: '#D97706', fontWeight: 700 }}>{chunks}</span>
                    ),
                  }}
                />
              )}
            </div>
            <div className={styles.upgradeNow} onClick={handleUpgradeClick}>
              <h2 className={styles.upgradeText}
                style={{ color: isCreditZero ? "#DC2626" : freeTrial ? "#2563EB" : "#D97706" }}>
                {isCreditZero ? (
                  <FormattedMessage id="settings.plan.feature.buyCredits" />
                ) : (
                  <FormattedMessage id="tolbar.usage.alert.btn" />
                )}
              </h2>
              <span className="flex-shrink-0 leading-[0]">
                <UpgradeNowIcon color={isCreditZero ? "#DC2626" : freeTrial ? "#2563EB" : "#D97706"} />
              </span>
            </div>
          </div>
        </AnimatedModal>
      )}
    </>
    )}
    </>
  );
};

